export const loadStores = catalogId => ({
  type: 'FETCH_STORES',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/stores/getStoresAllStatus?catalogId=${catalogId}`
    }
  }
})



// WEBPACK FOOTER //
// ./src/App/MainMenu/TradeMenu/SubItems/EcommerceStore/actions.js